import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import {
  fetchSingleAgent,
  approveAgent,
  disapproveAgent,
  deactivateAgentAccount,
} from '../../../state/redux/actions/agentActions.js'
import {
  fetchAgent,
  createAgent,
  updateAgent,
  deleteAgent,
} from '../services/agentApi.js'

const useAgent = agentId => {
  const dispatch = useDispatch()
  const { 
    singleAgent, 
    loading, 
    error, 
    deactivating, 
    deactivateError 
  } = useSelector(state => state.agent)

  useEffect(() => {
    if (agentId) {
      dispatch(fetchSingleAgent(agentId))
    }
  }, [dispatch, agentId])

  console.log('singleAgent:', singleAgent)
  
  return {
    agent: singleAgent,
    loading,
    error,
    deactivating,
    deactivateError,
    fetchAgent: agentId => dispatch(fetchSingleAgent(agentId)),
    createAgent: data => dispatch(createAgent(data)),
    approveAgent: agentId => dispatch(approveAgent(agentId)),
    disapproveAgent: agentId => dispatch(disapproveAgent(agentId)),
    deactivateAgent: ({ userId, message }) => dispatch(deactivateAgentAccount({ userId, message })),
    updateAgent: data => dispatch(updateAgent(data)),
    deleteAgent: id => dispatch(deleteAgent(id)),
  }
}

export default useAgent